import { render } from "./LoanForm.vue?vue&type=template&id=39e1fccc&scoped=true"
import script from "./LoanForm.vue?vue&type=script&lang=js"
export * from "./LoanForm.vue?vue&type=script&lang=js"

import "./LoanForm.vue?vue&type=style&index=0&id=39e1fccc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e1fccc"]])

export default __exports__